import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import { upcomingExam, type ExamScheduleOut } from "../api/examSchedules";
import { formatMoscowDateTime } from "../utils/datetime";

export function UpcomingExamCard() {
  const [exam, setExam] = useState<ExamScheduleOut | null | undefined>(undefined);

  useEffect(() => {
    void upcomingExam()
      .then(setExam)
      .catch(() => setExam(null));
  }, []);

  if (exam === undefined) return null;
  if (exam === null) return null;

  const when = formatMoscowDateTime(exam.scheduled_at, {
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  const format = exam.format === "in_person" ? "очно" : "онлайн";

  return (
    <section className="mt-4 overflow-hidden rounded-2xl bg-brand p-5 text-white shadow-sm">
      <div className="flex items-start gap-3">
        <CalendarClock size={20} strokeWidth={2} className="mt-0.5 shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="text-xs uppercase tracking-wide text-white/70">
            Предстоящий экзамен
          </div>
          <div className="mt-1 text-base font-semibold leading-snug">{when}</div>
          <div className="mt-0.5 text-xs text-white/80">Формат: {format}</div>
          {exam.comment && (
            <p className="mt-2 rounded bg-white/10 px-2 py-1.5 text-xs italic text-white/90">
              «{exam.comment}»
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
